import ContactDirectory from "@/components/ContactDirectory";

export default function Customers({ initialQuery = "" }) {
  return (
    <ContactDirectory
      initialQuery={initialQuery}
      title="Customers"
      subtitle="Your customer contact directory."
      endpoint="/customers"
      prefix="customer"
      singular="customer"
      addLabel="Add customer"
      regionMode
    />
  );
}
